export default __webpack_public_path__ + "static/microphone_b.ae3b8fe89a58f437ce3bcba08f527531.svg";